import { datafield, Entity } from '@wephone-core/model/model';

export class NumberLocationEntity extends Entity {
  static object_type_id = 'number_location';

  constructor(enterpriseId: number, isDefault: boolean) {
    super();

    this.is_default = isDefault ? 1 : 0;
    this.enterprise_id = enterpriseId;
  }

  @datafield id: number;
  @datafield enterprise_id: number;
  @datafield is_default: number;
  @datafield name: string;
  @datafield road_number: string;
  @datafield road_type: string;
  @datafield road_name: string;
  @datafield postal_code: string;
  @datafield city_name: string;
  @datafield insee_code: string;
  address: string;

  setObjectData(object_data: any, fetch_related_data = true): void {
    super.setObjectData(object_data, fetch_related_data);

    this.setAddress();
  }

  private setAddress(): void {
    const ret = [];
    if (this.road_number) {
      ret.push(this.road_number);
    }

    if (this.road_type) {
      ret.push(this.road_type);
    }

    if (this.road_name) {
      ret.push(this.road_name);
    }

    if (this.postal_code) {
      ret.push(this.postal_code);
    }

    if (this.city_name) {
      ret.push(this.city_name);
    }

    this.address = ret.join(' ');
  }
}
